<template>
    <div class="tree">
        <v-layout row align-start justify-start>
            <v-flex md6>
                <v-layout row justify-start align-start>
                    <v-flex xs2>
                        <div class="label text-xs-right">
                            <span class="text-xs-right">Search</span>
                        </div>
                    </v-flex>
                    <v-flex xs6>
                        <v-text-field
                            v-model="search"
                            label="Search for fleet or organization"
                            outline
                            single-line
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex md6>
                <div class="tree-title"> All available Organizations and Fleets </div>
                <div class="tree__wiev">
                    <v-treeview
                        v-if="filteredElements.length > 0"
                        item-key="id"
                        :items="filteredElements"
                        item-children="fleets"
                        open-all
                    >
                    <template v-slot:prepend="{ item }">
                        <v-checkbox
                            v-model="item.isAssigned"
                            :ripple="false"
                            @click.native="onCheckboxClick(item, $event)"
                        ></v-checkbox>
                    </template>
                    <template v-slot:label="{ item }">
                        <span :class="{ 'bold': item.fleets}">
                            {{item.name}}
                            <span
                                v-if="item.fleets && item.isAssigned && !hasAssignedFleet(item)"
                                class="all-fleets"
                            > (All fleets) </span>
                        </span>
                    </template>
                    </v-treeview>
                    <div v-if="!filteredElements.length" class="no-data">
                        No data matching your criteria
                    </div>
                </div>
            </v-flex>
            <v-flex md6>
                <div class="tree-title"> State preview </div>
                <div class="tree__wiev">
                    <v-treeview
                        v-if="filteredState.length > 0"
                        item-key="id"
                        :items="filteredState"
                        item-children="fleets"
                        open-all
                    >
                    <template v-slot:prepend="{ item }">
                        <v-checkbox
                            class="readonly-checkbox"
                            v-model="item.isAssigned"
                            disabled
                        ></v-checkbox>
                    </template>
                    <template v-slot:label="{ item }">
                        <span :class="{ 'bold': item.fleets}">
                            {{item.name}}
                            <span
                                v-if="item.fleets && item.isAssigned && !hasAssignedFleet(item)"
                                class="all-fleets"
                            > (All fleets) </span>
                        </span>
                    </template>
                    </v-treeview>
                    <div v-if="!filteredState.length" class="no-data">
                        No assigned fleets or organizations
                    </div>
                </div>
            </v-flex>
        </v-layout>
        <div class="tree__actions">
            <v-layout>
                <v-flex md12>
                    <div class="content-wrapper text-xs-right">
                        <sp-button @click.native="updateAssignedOrganizationsAndFleets" :disabled="isLoading" text="Save" icon="download"></sp-button>
                    </div>
                </v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>

import SpButton from '@/components/forms/Button'
import { flatArrayToNestedObj } from '@/helpers/Utils'

export default {
    name: 'TreeView',
    components: {
        SpButton
    },
    data () {
        return {
            tree: [],
            search: '',
            filteredState: {},
            filteredElements: [],
            copiedFlatList: [],
            treeList: []
        }
    },
    mounted () {
        this.onFilterState()
        this.onFilterElements()
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        flatList: {
            type: Array,
            required: true
        }
    },
    watch: {
        search: {
            handler (newVal, oldVal) {
                if (newVal) {
                    this.onFilterElements()
                } else {
                    this.filteredElements = this.treeList
                }
            }
        },
        flatList: {
            handler (newVal, oldVal) {
                this.copiedFlatList = JSON.parse(JSON.stringify(newVal))
                this.treeList = flatArrayToNestedObj(this.copiedFlatList)

                this.onFilterElements()
                this.onFilterState()
            },
            deep: true
        }
    },
    methods: {
        onCheckboxClick (item, e) {
            e.preventDefault()
            item.isAssigned = !item.isAssigned
            const isOrganization = item.hasOwnProperty('fleets')

            if (isOrganization && item.isAssigned) {
                //item.isAssigned = !item.isAssigned
                this.assignOrganization(item)
            } else if (isOrganization && !item.isAssigned) {
                this.unassignOrganization(item)
            } else if (!isOrganization && item.isAssigned) {
                this.assignFleet(item)
            } else if (!isOrganization && !item.isAssigned) {
                //item.isAssigned = !item.isAssigned
            }

            this.onFilterState()
            this.onFilterElements()
        },
        updateAssignedOrganizationsAndFleets () {
            this.$emit('onUpdateAssignedOrganizationsAndFleets', JSON.parse(JSON.stringify(this.copiedFlatList)))
        },
        assignOrganization (item) {
            const organization = this.copiedFlatList.find(org => org.id === item.id)
            item.isAssigned = true
            organization.isAssigned = true
        },
        unassignOrganization (item) {
            const organization = this.copiedFlatList.find(org => org.id === item.id)
            item.isAssigned = false
            organization.isAssigned = false
            for (let i = 0; i < organization.fleets.length; i++) {
                if (!organization.fleets[i].hasOwnProperty('fleets')) {
                    organization.fleets[i].isAssigned = false
                } else {

                }
            }
        },
        assignFleet (item) {
            for (let i = 0; i < this.copiedFlatList.length; i++) {
                const isInThisOrg = this.copiedFlatList[i].fleets.some(fleet => fleet.id === item.id)
                if (isInThisOrg && !this.copiedFlatList[i].isAssigned) {
                    this.copiedFlatList[i].isAssigned = true
                    return
                }
            }
        },
        hasAssignedFleet (item) {
            const organization = this.copiedFlatList.find(org => org.id === item.id)
            if (!organization.fleets.length) return true
            let hasFleet = false
            for (let i = 0; i < organization.fleets.length; i++) {
                const isOrganization = organization.fleets[i].hasOwnProperty('fleets')
                if (!isOrganization) {
                    hasFleet = true
                    if (organization.fleets[i].isAssigned) return true
                } else if (isOrganization && hasFleet) return false
                else return true
            }
        },
        onFilterState () {
            const ancestors = new Set()
            const activeOrgId = new Set()
            let flatList = JSON.parse(JSON.stringify(this.copiedFlatList))
            let activeOrganizations = flatList.filter(org => {
                if (true === org.isAssigned) {
                    ancestors.add(org.parentId)
                    activeOrgId.add(org.id)
                    return true
                } else {
                    return false
                }
            })

            const getAncestors = (organization) => {
                const parent = flatList.find(org => org.id === organization.parentId)
                if (organization.parentId) {
                    ancestors.add(parent.id)
                    getAncestors(parent)
                } else {
                    return
                }
            }
            activeOrganizations.forEach(organization => {
                getAncestors(organization)
            })

            const combinedSet = new Set([...ancestors, ...activeOrgId])
            const organizationsToDisplay = flatList.filter(org => combinedSet.has(org.id))

            if (0 === organizationsToDisplay.length) {
                this.filteredState = []
                return
            }

            organizationsToDisplay.forEach(org => {
                org.fleets = org.fleets.filter(fleet => !fleet.fleets && true === fleet.isAssigned)
            })
            this.filteredState = flatArrayToNestedObj(organizationsToDisplay)
        },
        onFilterElements () {
            let text = this.search.toLowerCase()
            let array = this.treeList

            const getNodes = (result, object) => {
                if (object.name.toLowerCase().includes(text)) {
                    result.push(object)
                    return result
                }
                if (Array.isArray(object.fleets)) {
                    const fleets = object.fleets.reduce(getNodes, [])
                    if (fleets.length) {
                        result.push({ ...object, fleets })
                    }
                }
                return result
            }
            this.filteredElements = array.reduce(getNodes, [])
        }
    }
}
</script>

<style lang="scss" scoped>
.tree {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: space-between;
}
.tree-title {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 10px;
}
.tree__wiev {
    overflow-x: auto;
    min-height: 400px;
    padding-top: 8px;
    margin: 0 5px 15px 0;
    border: 1px dotted black
}
.no-data {
    padding: 20px;
    font-weight: bold;
    text-align: center;
}
::v-deep .v-treeview-node {
    display: flex;
    flex-direction: column;
    position: relative;
    &__label {
        display: flex;
        align-items: center;
    }
    &__content {
        .v-input {
            flex: 0 0 auto;
        }
        .v-input__slot {
            margin: 0;
            min-height: auto !important;
        }
        .v-input--selection-controls__input {
            margin: 0;
        }
        .v-messages {
            display: none;
        }
    }
    .bold {
        font-weight: bold;
    }
    .custom-icon {
        margin-right: 5px;
    }
    .all-fleets {
        font-weight: normal;
    }
    .readonly-checkbox {
        cursor: move !important;
    }
}
</style>
